import Vue from 'vue'
import Vuex from 'vuex'


import * as actions from './actions'
import * as types from './types'
import * as fields from './fields'
import {parseMessage} from './api'

Vue.use(Vuex)
/*eslint camelcase: ["error", {properties: "never"}]*/
const loggedOutUser: types.Schema$User = {
  username: "",
  emailVerified: false,
  phoneNumber: "",
  sub: "",
  name: "",
  idToken: ""
}

const colors = 
[
'blue',
'yellow',
'green',
'white',
'purple',
'orange',
'violet',
'tomato'
]

let mapboxColors: any = []
colors.forEach((colorName,index) => {

  mapboxColors = [...mapboxColors, 
  // ['==', ['%', ['to-number',['get', 'layer']], colors.length], index],
    ['==', ['%', ['floor', ['+', ['to-number',['get', 'bin']], ['to-number',['get', 'layer']]]], colors.length], index],
    colorName]
})

const fieldLookup = (key: string) => {
  return fields.microplanLabelMap[key] ? 
    fields.microplanLabelMap[key] : 
    { label:  key, visible: false, id: key}
}

const unabbreviateType = (type: string) => {
  switch (type) {
    case 'ctch':
      return 'catchment'
    case 'mp':
      return 'microplan'
    case 'blocks':
      return 'pop_block'
    case 'hf':
      return 'health_facility'
    default:
      return 'NO_TYPE_FOUND'
  }
}

const recordToSource = (record: types.Schema$Layer) => {
  if(record.mapboxSourceUrl.startsWith('mapbox://')) {
     return  {
      id: record.name,
      url: record.mapboxSourceUrl,
      cc_type: unabbreviateType(record.type),
      type:  'vector' 
    }
  } else {
    return {
      id: record.name,
      data: record.mapboxSourceUrl,
      cc_type: unabbreviateType(record.type),
      type: 'geojson'
    }
  }
}

const recordToLayer = (record: types.Schema$Layer): Array<any> => {
  switch (record.type) {
    case 'mp':
     return [{
        id: record.name,
        cc_type: unabbreviateType(record.type),
        source: record.name,
        'source-layer' : record.type,
        label: 'Microplans',
        type: 'fill',
        layout: {
          visibility: 'visible',  
        },
        minzoom: 1,
        paint: {
          'fill-color' : [
            'case',
            ...mapboxColors,
            'red'
          ],  
          'fill-outline-color' : 'black',
          'fill-antialias' : true,
          'fill-opacity' : ['case', 
              ['boolean',['feature-state', 'hover'], false], 
              .2, 
              0.5 ]
        }
      },
      {
        id: `${record.name}-line`,
        cc_type: unabbreviateType(record.type),
        source: record.name,
        'source-layer' : record.type,
        label: 'Microplans',
        type: 'line',
        layout: {
          visibility: 'visible',  
        },
        paint: {
          'line-color' : 'black',
          'line-opacity' : 1.0,
          'line-width' : 1.0
          // 'fill-opacity' : ['case', 
          //     ['boolean',['feature-state', 'hover'], false], 
          //     .2, 
          //     0.5 ]
        }
      }]
    case 'blocks':
      return [{
        id: `${record.name}-fill`,
        cc_type: unabbreviateType(record.type),
        source: record.name,
        'source-layer' : record.type,
        label: 'Population Blocks',
        type: 'fill',
        layout: {
          visibility: 'visible',  
        },
        paint: {
          'fill-color': 'rgb(237, 228, 147)',  
          'fill-outline-color' : 'black',
          'fill-antialias' : true,
          'fill-opacity' : 0.6
          // 'fill-opacity' : ['case', 
          //     ['boolean',['feature-state', 'hover'], false], 
          //     .2, 
          //     0.5 ]
        }
      },{
        id: `${record.name}-line`,
        cc_type: unabbreviateType(record.type),
        source: record.name,
        'source-layer' : record.type,
        label: 'Population Blocks',
        type: 'line',
        layout: {
          visibility: 'visible',  
        },
        paint: {
          'line-color' : 'rgb(255, 255, 255)',
          'line-opacity' : 1.0,
          'line-width' : 1.0
          // 'fill-opacity' : ['case', 
          //     ['boolean',['feature-state', 'hover'], false], 
          //     .2, 
          //     0.5 ]
        }
      }]
    case 'hf':
      return [{
        id: record.name,
        cc_type: unabbreviateType(record.type),
        source: record.name,
        // 'source-layer' : record.type,
        label: "Health Facilities",
        type: "circle",
        // filter: ['in', ['get', 'Admin1'], ['literal', ['Addis Ababa', 'Tigray']]], //TODO: remove
        layout: {
          visibility: 'visible',  
        },
        minzoom: 2,
        paint: {
            "circle-radius": [
                "interpolate",
                ["linear"],
                ["zoom"],
                5, 1,
                16, 6
            ],                
            'circle-color': 'rgb(227,116,118)',
            "circle-stroke-color": "black",
            "circle-stroke-width": .5,
        }
      }]
    case 'ctch':
      return [{
        id: `${record.name}-line`,
        cc_type: unabbreviateType(record.type),
        source: record.name,
        'source-layer' : record.type,
        label: 'Catchments',
        type: 'line',
        layout: {
          visibility: 'visible',  
        },
        minzoom: 2,
        paint: {
          // 'line-color': '#D3D3D3',
          'line-width' : ['case', 
                            ['boolean',['feature-state', 'hover'], false], 
                            4.0, 
                            1.4 ],
          'line-color' : 'rgb(227,116,118)',
         
          'line-opacity' : ['case', 
                            ['boolean',['feature-state', 'hover'], false], 
                            1.0, 
                            0.6 ],
        }
      },
      {
        id: `${record.name}-fill`,
        cc_type: unabbreviateType(record.type),
        source: record.name,
        'source-layer' : record.type,
        label: 'Catchments',
        type: 'fill',
        layout: {
          visibility: 'visible',  
        },
        minzoom: 2,
        paint: {
          // 'fill-color': '#D3D3D3',  
          'fill-color' : ['case',
                            ['>', ['get', 'tot_pop'], 1000], 'red',
                            '#D3D3D3'
                          ],
          'fill-antialias' : true,
          'fill-opacity' : ['case',
                            ['==', ['get', 'tot_pop'], null], 0.0,
                            ['>', ['get', 'tot_pop'], 100000000], 0.3,
                            0.0
                          ]
        }
      }]
    default: 
      return [{}]
  }
}

let connection = null as null | WebSocket;

const store = new Vuex.Store({
  state: {
    user: loggedOutUser,
    apiBase: 'wss://o5w9s9n6nk.execute-api.us-east-1.amazonaws.com/prod',
    map: {
      sources: [],
      layers: []
    },
    showData: false,
    dataTab: "catchment",
    data: {
      site: {
        fields: [{value: "field", text: "Field"}, {value: "value", text:"Value"}],
        items: [],
        name: "",
        id: "",
        // items: [{field: "Blarg", value: "BlargValue"}]
      },
      microplan: {
        fields: [{value: "field", text: "Field"}, {value: "value", text:"Value"}],
        items: []
        // items: [{field: "Blarg", value: "BlargValue"}]
      },
      catchment: {
        fields: [{value: "field", text: "Field"}, {value: "value", text:"Value"}],
        items: []
        // items: [{field: "Blarg", value: "BlargValue"}]
      },
      population: {
        fields: [{value: "field", text: "Field"}, {value: "value", text:"Value"}],
        items: []
      }
    }
  },
  getters: {
    loggedIn: (state: any) => (state.user.sub != '' && state.user.sub != 'NULL_SUB')
  },
  mutations: {
    [actions.SET_TAB]: (state: any, tab: string) => {
      state.dataTab = tab
    },
    [actions.UPDATE_USER]: (state, user: types.Schema$User) => {
      state.user = user
    },
    [actions.LOG_OUT]: (state: any) => {
      state.user = loggedOutUser
    },
    [actions.TOGGLE_DATA_WINDOW]: (state: any) => {
      state.showData = !state.showData
    },
    [actions.SHOW_DATA]: (state: any, show: boolean) => {
      state.showData = show
    },
    [actions.TOGGLE_LAYER]: (state: any, id: string) => {
      const index = state.map.layers.findIndex((layer: any) => layer.id === id)
      
      state.map.layers = state.map.layers.map((layer: any) => {
        if(layer.id === id) {
          return Object.assign({},{
            ...layer,
            layout: {
              ...layer.layout,
              visibility: (layer.layout.visibility === 'visible') ? 'none' : 'visible'
            }
          })
        } else {
          return layer
        }
      }) 
    },
    [actions.SET_LAYERS]: (state: any, layers: Array<any>) => {
      state.map.sources = layers.map((r) => recordToSource(r))
      state.map.layers = layers.reduce((accumulator, r: types.Schema$Layer) => {
        const layers = recordToLayer(r)
        accumulator = [...accumulator, ...layers]
        return accumulator
      },[])
      .sort((a: types.Schema$MapboxSource, b: types.Schema$MapboxSource) => {
        //this determines the order in which things are added to the map,
        //and hence which layers appear on top of which others
        const typeToVal = (type: string) => {
          switch(type) {
            case 'health_facility':
              return 4;
            case 'microplan':
              return 3;
            case 'catchment':
              return 2;
            case 'pop_block':
              return 1;
            default:
              return 0;
          }
        }
        /* eslint camelcase: off */
        // eslint @typescript-eslint/camelcase: ["error", {allow: ["cc_type"]}]
        return typeToVal(a?.cc_type ?? "") - typeToVal(b?.cc_type ?? "")
      })
    },
    [actions.SET_DATA]: (state: any, data: any) => {
      state.data.site.items = [...data.site.items]
      state.data.site.name = data?.site?.name ?? ""
      // state.data.site.items = [...data.site.items]
      state.data.microplan.items = [...data.microplan.items]
      state.data.catchment.items = [...data.catchment.items]
    },
    [actions.SET_SITE]: (state: any, data: any) => {
      // state.data.site.items = [...data.site.items]
      // console.log(data)
      state.data.site.items = [...data.items]
    },
    [actions.SET_POPULATION]: (state: any, data: any) => {
      state.data.population.items = Object.entries(data.population).map(([field,value]: Array<any>): any => (
          {
            field: fields.populationFieldLookup(field),
            value: (Math.floor(parseInt(value)) + 1).toLocaleString()
          }
        )
      ) as any
    }
  },
  actions: {
    [actions.CREATE_WEBSOCKETS_CONNECTION]: ({state, commit}) => {
      if (connection == null) {
        return new Promise((resolve,reject) => {
          try {
            connection = new WebSocket(state.apiBase+`?token=${state.user.idToken}`)
            connection.onmessage = (event) => {
              // useful for testing reactivity to ensure we don't need the
              // api to respond before we load the map. just comment this back in
              // setTimeout(() => void parseMessage({state, commit, event}),10000)
              parseMessage({state, commit, event})
            }
            connection.onopen = (event) => {
              resolve(event)
            }  
          } catch(error) {
            console.warn("authentication error")
            reject(error)
          }
        })
      } else {
        return Promise.resolve();
      }
    },
    [actions.FETCH_LAYERS]: ({state,commit}) => {
      (connection as WebSocket).send(JSON.stringify({userId: '0', type: 'listLayers'}))
    }
  },
  modules: {
  }
})

export default store;
